import React from 'react';
import { Button } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import { FiAlertCircle, FiAlertTriangle, FiInfo, FiInbox, FiRefreshCw, FiX } from 'react-icons/fi';

export const preventEnterSubmit = (e) => {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT') e.preventDefault();
};

export const SectionCard =({ title, subtitle, actions, children, footer, bodyClassName = '' }) => (
    <div className="ss-card">
        {(title || actions) && (
            <div className="ss-card-header">
                <div>
                    {title && <h5 className="ss-card-title">{title}</h5>}
                    {subtitle && <p className="ss-card-subtitle">{subtitle}</p>}
                </div>
                {actions}
            </div>
        )}
        <div className={`ss-card-body ${bodyClassName}`}>{children}</div>
        {footer}
    </div>
);

export const PageLoader = ({ text = 'Loading...' }) => (
    <div className="ss-state" role="status" aria-live="polite">
        <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} />
        <span>{text}</span>
    </div>
);

export const EmptyState = ({ icon, title, text, action }) => (
    <div className="ss-state">
        <span className="ss-state-icon">{icon || <FiInbox />}</span>
        {title && <span className="ss-state-title">{title}</span>}
        {text && <span className="ss-state-text">{text}</span>}
        {action}
    </div>
);

export const ErrorState = ({ title = 'Could not load data', message, onRetry }) => (
    <div className="ss-state is-error" role="alert">
        <span className="ss-state-icon"><FiAlertCircle /></span>
        <span className="ss-state-title">{title}</span>
        {message && <span className="ss-state-text">{message}</span>}
        {onRetry && (
            <Button variant="outline-primary" size="sm" className="mt-2" onClick={onRetry}>
                <FiRefreshCw /> Try again
            </Button>
        )}
    </div>
);

const ALERT_ICONS = { error: <FiAlertCircle />, warning: <FiAlertTriangle />, info: <FiInfo /> };

export const AlertBox = ({ variant = 'error', title, messages, onClose }) => {
    const list = (Array.isArray(messages) ? messages : [messages]).filter(Boolean);
    if (!title && list.length === 0) return null;
    return (
        <div className={`ss-alert is-${variant}`} role={variant === 'error' ? 'alert' : 'status'}>
            <span className="ss-alert-icon">{ALERT_ICONS[variant]}</span>
            <div className="ss-alert-body">
                {title && <strong className="d-block">{title}</strong>}
                {list.length === 1 && !title && list[0]}
                {(list.length > 1 || (title && list.length > 0)) && (
                    <ul>{list.map(message => <li key={message}>{message}</li>)}</ul>
                )}
            </div>
            {onClose && (
                <button type="button" className="ss-alert-close" aria-label="Close" onClick={onClose}><FiX /></button>
            )}
        </div>
    );
};
